<template>
  <div class="pageContent">
    <div class="pageTitleBox" @click="$router.push({name: 'xinwen'})">
      <div><img src="../../assets/images/news2.png" alt="logo" class="pageTitleIcon">新闻资讯</div>
      <span @click="$router.push({name: 'xinwen'})" class="back">返回</span>
    </div>
    <h2 class="title">{{ title }}</h2>
    <div class="content ql-editor" ref="content"></div>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  name: 'XinwenDetail',
  data() {
    return {
      data: '<p><span style=\"font-size: 18pt;\">dvgdfgydfg</span></p>',
      title: ''
    }
  },
  mounted() {
    this.onload()
  },
  methods: {
    onload() {
      let parameter = {
        headline: this.$route.query.noticeName,
        pageNum: 1,
        pageSize: 99999,
        type: 2
      }
      http('/system/announcement/getList', 'POST', parameter).then(res => {
        if (res.success) {
          res.data.resultList.forEach(item => {
            if (item.id == this.$route.query.noticeId) {
              this.$refs.content.innerHTML = item.content
              this.title = item.headline
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pageContent {
  width: 1220px;
  margin: 18px auto;
  padding: 0 32px;
}
.title {
  text-align: center;
  margin: 24px auto;
}
.content {
  min-height: 300px;
  padding-bottom: 24px;
}
.pageTitleBox {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  .back {
    color: #519bcd;
    cursor: pointer;
  }
}
</style>